import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, throwError, switchMap } from 'rxjs';

let authRedirectInProgress = false;

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const oidcSecurityService = inject(OidcSecurityService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      return oidcSecurityService.isAuthenticated().pipe(
        switchMap((isAuthenticated) => {
          if (!isAuthenticated && !authRedirectInProgress) {
            authRedirectInProgress = true;
            oidcSecurityService.authorize();
          }

          return throwError(() => error);
        })
      );
    })
  );
};
